<template>
  <div class="component d-flex flex-direction-row justify-content-center flex-wrap">
    <router-link to="/admin/methods" class="w-100 m-2 p-3 bg-dark" style="max-width: 450px;">
      <div class="">
        <h2 class="display-5">Methods</h2>
        <p class="">Добавление новых и просмотр старых методов</p>
      </div>
    </router-link>
    <router-link to="/admin/themes" class="w-100 m-2 p-3 bg-dark" style="max-width: 450px;">
      <div class="">
        <h2 class="display-5">Themes</h2>
        <p class="">Добавление новых и просмотр старых тем</p>
      </div>
    </router-link>
    <router-link to="/admin/previews" class="w-100 m-2 p-3 bg-dark" style="max-width: 450px;">
      <div class="">
        <h2 class="display-5">Previews</h2>
        <p class="">Добавление новых и просмотр старых превью</p>
      </div>
    </router-link>
    <router-link to="" class="w-100 m-2 p-3 bg-dark" style="max-width: 450px;">
      <div class="">
        <h2 class="display-5">Позже добавлю</h2>
        <p class="">Позже добавлю</p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Main",
}
</script>

<style scoped>

</style>
